import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createUnrealisedIncomeReportApi } from "./api";
import { UnRealisedIncomeReduxTypes } from "./types";

function* createUnrealisedIncomeReportSaga(action:any):Generator {
    try {
        const response: any = yield call(createUnrealisedIncomeReportApi, action.payload);
        yield put({
            type: UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchCreateUnrealisedIncomeReport(): SagaIterator {
    yield takeEvery(UnRealisedIncomeReduxTypes.UNREALISED_INCOME_REPORT, createUnrealisedIncomeReportSaga);
}

function* unrealisedIncomeReportSaga(): SagaIterator {
    yield all([fork(watchCreateUnrealisedIncomeReport)]);
}

export default unrealisedIncomeReportSaga;  